import PropTypes from 'prop-types';
import AbstractInput from '../abstract_input';

class BooleanSwitch extends AbstractInput {
  constructor(props) {
    super(props);

    this.state = {
      checked: this.props.value,
      validationErrors: [],
      pristine: true,
    };

    this.handleChanged = this.handleChanged.bind(this);
  }

  handleChanged(e) {
    this.props.onChange(e.target, !this.state.checked);
    this.setState({
      checked: !this.state.checked,
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.updateStateOnPropsChange && this.props.value != this.state.checked) {
      this.setState({ checked: this.props.value });
      this.props.onChange({ checked: this.props.value }, !this.state.checked);
    }
  }

  render() {
    return (
      <div className={this.props.wrapperClassName}>
        <input type="hidden" value="false" name={this.props.name} />
        <input
          type="checkbox"
          className="hidden"
          id={this.props.id}
          checked={this.state.checked}
          name={this.props.name}
          value="true"
          onChange={this.handleChanged}
          disabled={this.props.disabled}
        />
        <label
          className={`switch-container ${this.state.checked ? 'active' : ''} ${this.props.className}`}
          htmlFor={this.props.id}
          {...this.props.attributes}
        >
          <div className="switch-circle">
            <span className="switch" />
          </div>
        </label>
      </div>
    );
  }
}

BooleanSwitch.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  checked: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  wrapperClassName: PropTypes.string,
  updateStateOnPropsChange: PropTypes.bool,
};

BooleanSwitch.defaultProps = {
  checked: false,
  label: '',
  onChange: () => {},
  disabled: false,
  wrapperClassName: '',
  updateStateOnPropsChange: false,
};

export default BooleanSwitch;
